import { MODE_CALCUL_FORFAIT, MODE_CALCUL_MANUEL } from '@/configuration/tiers/tiersConf';
import calculArrondi from '@/services/calcul/calculArrondi';
import * as produitConf from '@/configuration/produitConf';

export function calculHonoraire(modeCalculHonoraire, montantHtLocation, montantHtTlpe, montantHtDivers) {
  if (!modeCalculHonoraire) return 0;
  const {
    modeCalcul,
    montantForfaitHt = 0,
    pourcentage = 0,
    applicableSurLocation,
    applicableSurTlpe,
    applicableSurDivers,
  } = modeCalculHonoraire;

  if (modeCalcul === MODE_CALCUL_MANUEL) return 0;

  if (modeCalcul === MODE_CALCUL_FORFAIT) return montantForfaitHt || 0;
  const bases = [
    { active: applicableSurLocation, montant: montantHtLocation },
    { active: applicableSurTlpe, montant: montantHtTlpe },
    { active: applicableSurDivers, montant: montantHtDivers },
  ];

  const baseHt = bases
    .filter(b => b.active)
    .reduce((sum, b) => sum + (b.montant || 0), 0);

  if (baseHt === 0 || pourcentage === 0) return 0;

  return baseHt > 0 && pourcentage > 0
    ? calculArrondi(baseHt * (pourcentage / 100), 2)
    : 0;
}

export function getTotalAvecRemiseTlpe(ligneRegroupement) {
  const lignesEnfantTlpe = ligneRegroupement.lignesCommande
    .filter((ligneEnfant) => {
      return ligneEnfant.typeProduit === produitConf.CATEGORIE_DIVERS
        && ligneEnfant.produit && ligneEnfant.produit.produitDivers
        && ligneEnfant.produit.produitDivers.tlpe;
    });
  if (lignesEnfantTlpe.length === 0) return 0;
  return lignesEnfantTlpe
    .map((el) => { return el.totalHtAvecLigneRemise; })
    .reduce((a, b) => { return a + b; });
}

export function getTotalAvecRemiseLocation(ligneRegroupement) {
  const ligneEnfantLocation = ligneRegroupement.lignesCommande
    .filter((ligneEnfant) => {
      return ligneEnfant.typeProduit === produitConf.CATEGORIE_LOCATION;
    });
  if (ligneEnfantLocation.length === 0) return 0;
  return ligneEnfantLocation
    .map((el) => { return el.totalHtAvecLigneRemise; })
    .reduce((a, b) => { return a + b; });
}

export function getTotalAvecRemiseDivers(ligneRegroupement) {
  const ligneEnfantDivers = ligneRegroupement.lignesCommande
    .filter((ligneEnfant) => {
      return ligneEnfant.typeProduit === produitConf.CATEGORIE_DIVERS
        && ligneEnfant.produit && ligneEnfant.produit.produitDivers
        && !ligneEnfant.produit.produitDivers.tlpe
        && !ligneEnfant.produit.produitDivers.honoraire;
    });
  if (ligneEnfantDivers.length === 0) return 0;
  return ligneEnfantDivers
    .map((el) => { return el.totalHtAvecLigneRemise; })
    .reduce((a, b) => { return a + b; });
}

export function updateModeCalculHonoraireBudget(budget, modeCalcul) {
  const { prixNet, tlpe, fraisTechnique } = budget;
  budget.modeCalculHonoraire = modeCalcul || null;
  budget.honoraires = calculHonoraire(modeCalcul, prixNet, tlpe, fraisTechnique);
  budget.honoraireFraisTraitement = modeCalcul ? modeCalcul.montantHonoraireFraisTraitement : 0;
}
